import { render, staticRenderFns } from "./ReviewerReviewActions.vue?vue&type=template&id=17c6c243&"
import script from "./ReviewerReviewActions.vue?vue&type=script&lang=js&"
export * from "./ReviewerReviewActions.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerReviewActions.vue?vue&type=style&index=0&id=17c6c243&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports